import React from 'react';
import Trainings from './Components/Trainings/Trainings';
import AvgTicket from './Components/AvgTicket';
import AvgCheckSize from './Components/AvgCheckSize';
import ProductSalesLeaderboard from './Components/ProductSalesLeaderboard';
import BOHComments from './Components/BOHComments';
import ShiftTask from './Components/ShiftTask';
import CustomerSatisfactionRates from './Components/CustomerSatisfactionRates';
import SpeedOfService from './Components/SpeedOfService';
import StoreSpeedOfService from './Components/StoreSpeedOfService';
import HuddleBoard from './Components/HuddleBoard';
import ThermometerSalesGoal from './Components/ThermometerSalesGoal';
import SameStoreSales from './Components/SameStoreSales';
import AvgGuestSpend from './Components/AvgGuestSpend';
import ProductSalesByStore from './Components/ProductSalesByStore';
import BlazinAttachment from './Components/BlazinAttachment';
import PercentageToGoal from './Components/PercentageToGoal';
import BlazinByStore from './Components/BlazinByStore';
import Bio from './Components/Bio';
import TrainingByStore from './Components/TrainingByStore';
import EmployeeHighlight from './Components/EmployeeHighlight';
import Celebration from './Components/Celebration';
import MultiCelebration from './Components/MultiCelebration';
import EmployeeLoyaltyLeaderboard from './Components/EmployeeLoyaltyLeaderboard';
import HuddleNotes from './Components/HuddleNotes';
import MetricsDashboard from './Components/MetricsDashboard';
import ACRByStoreLeaderboard from './Components/ACRByStoreLeaderboard';
import Shoutout from './Components/Shoutout';
import PayDay from './Components/PayDay';
import ProductHighlight from './Components/ProductHighlight';
import Poll from './Components/Poll';
import { getSpotlightStyles } from '../helpers/utils';
const BOHRendererMap = {
  boh_type_training_course: Trainings,
  boh_type_location_avg_ticket: AvgTicket,
  boh_type_avg_check_size: AvgCheckSize,
  boh_type_product_sales_leaderboard: ProductSalesLeaderboard,
  boh_type_customer_comments: BOHComments,
  boh_type_shift_log: ShiftTask,
  boh_type_nps: CustomerSatisfactionRates,
  boh_type_drive_thru_sos: SpeedOfService,
  boh_type_store_speed_of_service: StoreSpeedOfService,
  boh_type_huddle_board: HuddleBoard,
  boh_type_thermometer_sales: ThermometerSalesGoal,
  boh_type_same_store_sales: SameStoreSales,
  boh_type_avg_guest_spend: AvgGuestSpend,
  boh_type_product_sales_by_store: ProductSalesByStore,
  boh_type_percentage_to_goal: PercentageToGoal,
  boh_type_bio: Bio,
  boh_type_employee_highlight: EmployeeHighlight,
  boh_type_blazin_by_store: BlazinByStore,
  boh_type_blazin_attachment: BlazinAttachment,
  boh_type_training_by_store: TrainingByStore,
  boh_type_birthday: Celebration,
  boh_type_anniversary: Celebration,
  boh_type_birthday_single_employee: Celebration,
  boh_type_anniversary_single_employee: Celebration,
  boh_type_multi_birthday: MultiCelebration,
  boh_type_multi_anniversary: MultiCelebration,
  boh_type_employee_loyalty_leaderboard: EmployeeLoyaltyLeaderboard,
  boh_type_huddle_notes: HuddleNotes,
  boh_type_employee_shoutout: Shoutout,
  boh_type_payday: PayDay,
  boh_type_product_highlight: ProductHighlight,
  boh_type_metrics_dashboard: MetricsDashboard,
  boh_type_poll: Poll,
  boh_type_acr_by_store: ACRByStoreLeaderboard
};
const BOHComponent = ({
  properties,
  type,
  data,
  duration,
  metadata,
  tracking,
  text,
  deviceId,
  organizationId,
  playing
}) => {
  const BOHRenderer = BOHRendererMap[type];
  if (!BOHRenderer) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: `BackOfHouse ${type}`,
    style: {
      backgroundColor: 'transparent'
    }
  }, /*#__PURE__*/React.createElement(BOHRenderer, {
    data: data,
    duration: duration,
    metadata: metadata,
    tracking: tracking,
    text: text,
    properties: properties,
    type: type,
    deviceId: deviceId,
    organizationId: organizationId,
    playing: playing,
    bohStyle: getSpotlightStyles(metadata, text)
  }));
};
export default BOHComponent;